import LeadSetting from './LeadSetting';

export default LeadSetting;
